import type { User } from '@c214/shared';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useNavigate } from 'react-router-dom';
import { useLogout } from '../../hooks/useAuth';

const ITEMS = [
  { to: '/orders', label: 'Мої замовлення' },
  { to: '/favorites', label: 'Улюблене' },
  { to: '/subscription', label: 'Підписка на каву' },
  { to: '/profile', label: 'Особисті дані' },
];

export function ProfileMenu({ user, children }: { user: User; children: React.ReactNode }) {
  const navigate = useNavigate();
  const logout = useLogout();

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>{children}</DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={8}
          className="z-30 min-w-[210px] border border-line bg-surface-2 p-2"
        >
          <div className="border-b border-line-soft px-3 py-2">
            <p className="text-[14px] font-semibold text-ink">{user.name ?? user.email}</p>
            {user.phone && (
              <p className="mt-[3px] font-mono text-[10px] text-muted-2">{user.phone}</p>
            )}
          </div>
          {ITEMS.map((item) => (
            <DropdownMenu.Item
              key={item.to}
              onSelect={() => navigate(item.to)}
              className="cursor-pointer px-3 py-[10px] text-[14px] text-ink outline-none hover:bg-line-soft"
            >
              {item.label}
            </DropdownMenu.Item>
          ))}
          <DropdownMenu.Item
            onSelect={() => logout.mutate()}
            className="cursor-pointer px-3 py-[10px] text-[14px] text-muted outline-none hover:bg-line-soft"
          >
            Вийти
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
